module.exports = __webpack_public_path__ + "img/client (5).5bab3710.jpg";